import type { IDestinationLink } from '../../../../../../../../models/destination-link.model';
import { DateHelper } from '../../../../../../../../helpers/date.helper';
import TravelTo from '../TravelTo';

function DestinationLink({ destinationLink }: { destinationLink: IDestinationLink }) {
  return (
    <div className="destination-link">
      <TravelTo
        transportMode={destinationLink.transportMode}
        durationInMinutes={
          destinationLink.plannedDepartureTime && destinationLink.plannedArrivalTime
            ? DateHelper.getDurationFromDateStrings(destinationLink.plannedDepartureTime, destinationLink.plannedArrivalTime)
            : undefined
        }
        distanceInMeters={destinationLink.distanceInMeters}
      ></TravelTo>
    </div>
  );
}

export default DestinationLink;
